import React, { Component } from 'react';
import { RotatingLines, ThreeDots } from 'react-loader-spinner';
import { randomString } from '../../../services/CommonFunction';
import { messageService, modalPopup } from '../../../services/subscriberService';
import PropTypes from 'prop-types';

import './Loader.scss';

// "react-loader-spinner": "^3.1.14",
class Spinner extends Component {
    state = {
        show: false,
        percent: null,
        text: ''
    }

    componentDidMount() {
        this.subscription = messageService.getMessage().subscribe(data => {
            if (data) {
                this.setState({ show: data.show });
            }
        });
        this.subscriptionPercent = messageService.getPercentMessage().subscribe(data => {
            this.setState({ percent: data.percent, text: data.text });
        });
    }

    componentWillUnmount() {
        this.subscription.unsubscribe();
        this.subscriptionPercent.unsubscribe();
    }

    render() {
        const { show, percent, text } = this.state;
        const per = percent !== null ? <React.Fragment>
            <span key="percent" className="percent">{percent}%</span>
            <span className="percent_text">{text || ''}</span>
        </React.Fragment> : null;
        const loader = <ThreeDots key="loader" className="loader" visible={this.state.show} color={modalPopup.color} height={50} width={100} />
        return (
            <React.Fragment>
                {show && <div className="backgroundC">
                    {per}
                    {loader}
                </div>}
            </React.Fragment>
        );
    }
}


export default Spinner;

export const SmallLoader = ({ clas, show, ...props }) => (
    <div className="backgroundC smallLoader">
        <RotatingLines className={clas} key={randomString(10)} strokeColor="grey" className="loader" strokeWidth="3" animationDuration="0.5" width="50" visible={show} />
        {/* <Loader key={randomString(10)} className="loader" visible={true} type="ThreeDots" color={modalPopup.color} height={50} width={100} /> */}
    </div>
)

SmallLoader.propTypes = {
    clas: PropTypes.string,
    show: PropTypes.bool,
}

SmallLoader.defaultProps = {
    clas: '',
    show: true
}
